module.exports = __webpack_public_path__ + "img/sales-partner-get-started-hero-banner.adadd943.svg";